import { forwardRef, MouseEventHandler, useEffect, useState } from 'react';
import { Assert } from '@team/assert';
import { clsx } from '@team/clsx';
import { Container } from '../../blocks/container';
import { Basic } from './components/basic';
import { type EntryProps } from './types';
import { DEFAULT_DURATION } from './const';
import css from './style.module.css';

export const Entry = forwardRef<HTMLDivElement, EntryProps>(function Component(
  { duration = DEFAULT_DURATION, onClick, onClose, onActionClick, ...props },
  forwardedRef
) {
  const [isShown, setShown] = useState(false);

  useEffect(() => {
    setShown(true);
  }, []);

  useEffect(() => {
    if (!isShown) {
      return;
    }

    const timeout = window.setTimeout(setShown, duration, false);

    return () => {
      window.clearTimeout(timeout);
    };
  }, [isShown, duration]);

  const handleTransitionEnd = () => {
    if (!isShown && Assert.isFunction(onClose)) {
      onClose();
    }
  };

  const handleClick: MouseEventHandler<HTMLDivElement> = (event) => {
    setShown(false);

    if (Assert.isFunction(onClick)) {
      onClick(event);
    }
  };

  return (
    <Container
      className={clsx(css.root, {
        [css.mount]: isShown,
        [css.unmount]: !isShown,
      })}
      ref={forwardedRef}
      onTransitionEnd={handleTransitionEnd}
    >
      <Basic
        {...props}
        onClick={handleClick}
        onActionClick={onActionClick}
        ref={forwardedRef}
      />
    </Container>
  );
});
